// 許可ドメイン（t_user_add.domain のカンマ区切り）の解析・検証（形式と上限はサーバー側 services/admin_ops.py の OPS_DOMAIN_PATTERN と同期させること）
export const DOMAIN_MAX_LENGTH = 255;

const LABEL = "[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?";
const DOMAIN_PATTERN = new RegExp(`^(?:\\*\\.)?${LABEL}(?:\\.${LABEL})*(?::(\\d{1,5}))?$`);

/** カンマ区切り → 配列（空要素は除く） */
export const parseDomains = (csv) => (csv ?? "").split(",").map((d) => d.trim()).filter(Boolean);

/** 入力値をサーバーが照合する host[:port] の形に揃える（貼り付けた URL のスキーム・パスを除く） */
export const normalizeDomain = (input) => (input ?? "")
    .trim()
    .toLowerCase()
    .replace(/^[a-z][a-z0-9+.-]*:\/\//, "")
    .replace(/[/?#].*$/, "");

/** 1件の形式エラー（無ければ空文字。空欄はエラーにしない） */
export const domainError = (input) => {
    const domain = normalizeDomain(input);
    if (!domain) return "";
    const match = DOMAIN_PATTERN.exec(domain);
    const port = match?.[1];
    if (!match || (port && (Number(port) < 1 || Number(port) > 65535))) {
        return "ドメインの形式が正しくありません（例: www.example.com / *.example.com）";
    }
    return "";
};

const normalizedList = (list) => (list ?? []).map(normalizeDomain).filter(Boolean);

/** 保存する値（正規化して空行を除いたカンマ区切り） */
export const joinDomains = (list) => normalizedList(list).join(",");

/** 行ごとのエラーと、リスト全体のエラー */
export const domainListErrors = (list) => {
    const seen = new Set();
    const rows = (list ?? []).map((input) => {
        const error = domainError(input);
        if (error) return error;
        const domain = normalizeDomain(input);
        if (!domain) return "";
        if (seen.has(domain)) return "同じドメインが重複しています";
        seen.add(domain);
        return "";
    });
    const joined = joinDomains(list);
    let listError = "";
    if (!joined) listError = "許可ドメインを1件以上登録してください";
    else if (joined.length > DOMAIN_MAX_LENGTH) listError = `合計 ${DOMAIN_MAX_LENGTH} 文字以内にしてください（現在 ${joined.length} 文字）`;
    return { rows, list: listError };
};

export const hasDomainErrors = (list) => {
    const { rows, list: listError } = domainListErrors(list);
    return !!listError || rows.some(Boolean);
};

/** 保存済みの値（未正規化のまま）と編集中の値を比べる。並び順の違いも変更とみなす */
export const domainsChanged = (saved, draft) => draft !== null && draft !== undefined && (saved ?? []).join(",") !== joinDomains(draft);

/** 確認モーダル用の追加・削除分 */
export const domainDiff = (saved, draft) => {
    const before = normalizedList(saved);
    const after = normalizedList(draft);
    return {
        added: after.filter((d) => !before.includes(d)),
        removed: before.filter((d) => !after.includes(d)),
    };
};
